export default () => ({
  memberId: '',
  memberRole: ''
})



// WEBPACK FOOTER //
// ./src/store/modules/admin/hangfire/state.js